import palette from './palette';

const icon = {
  MuiSvgIcon: {
    defaultProps: {
      color: 'action',
    },
    styleOverrides: {
      colorAction: {
        color: palette.grey[800],
        '.MuiIconButton-root:hover &, .MuiIconButton-root:hover:active &, .MuiIconButton-root:focus-visible &': {
          color: palette.common.white,
        },
      },
      colorSecondary: {
        color: palette.grey[600],
      },
      colorError: {
        '.MuiButtonBase-root:hover > &, .MuiButtonBase-root:hover:active > &, .MuiButtonBase-root:focus-visible > &': {
          color: palette.common.white,
        },
      },
    },
  },
};
export default icon;
